import $ from 'jquery';
// import styleguide from "./modules/style-guide.js";
import accordions from './modules/accordions.js';
// import cards from "./modules/cards.js";
import circlesLib from './vendor/circles.js';
import circleEffect from './modules/circles.js';
import menu from './modules/menu.js';
// import sliders from "./modules/sliders.js";
// import svg from "./modules/svg.js";
import MainMenuTabbing from './modules/mainMenuTabber.js';
import pageContainerMargin from './modules/pageContainerMargin.js';
import headerScroll from './modules/headerScroll.js';
import search from './modules/search.js';

// Make sure that you init the styleguide first.
// styleguide.init();
accordions.init();
circleEffect.init();
// cards.init();
menu.init();
// sliders.init();
// svg.init();
MainMenuTabbing.init();
headerScroll.init();
search.init();

if (!document.body.classList.contains('home')) {
	pageContainerMargin.init();
}
